import { render, staticRenderFns } from "./birthInfo.vue?vue&type=template&id=ba61d128&scoped=true"
import script from "./birthInfo.vue?vue&type=script&lang=js"
export * from "./birthInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba61d128",
  null
  
)

export default component.exports